import React from 'react';
import { GeneralDataProtection } from '../../logic/components';

const GeneralUserDataRoute = () => {
  return (
    <div className="container">
      <GeneralDataProtection />
    </div>
  );
};

export default React.memo(GeneralUserDataRoute);
